import { useState, useEffect } from 'react';
import ScrollReveal from '../../../components/feature/ScrollReveal';

const WEDDING_DATE = new Date('2026-07-25T16:30:00').getTime();

function getTimeLeft() {
  const now = new Date().getTime();
  const distance = WEDDING_DATE - now;
  if (distance <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  return {
    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
    hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((distance % (1000 * 60)) / 1000),
  };
}

export default function Countdown() {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative py-16 sm:py-32 px-6" style={{ background: '#F5F0E8' }}>
      <div className="relative z-10 max-w-6xl mx-auto">

        <ScrollReveal direction="up">
          <div className="text-center mb-12 sm:mb-16 space-y-3">

            <h2 className="text-5xl sm:text-6xl md:text-7xl font-serif italic text-[#2A1A14]">
              До встречи осталось
            </h2>
            <div className="flex items-center gap-3 justify-center pt-1">
              <div className="h-px w-12 bg-[#A8323C]/50" />
              <span className="text-[#A8323C] text-sm">✦</span>
              <div className="h-px w-12 bg-[#A8323C]/50" />
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={200}>
          {/* Ornate outer frame */}
          <div className="relative">
            {/* Shadow offset */}
            <div className="absolute inset-0 translate-x-2 translate-y-2 border border-[#A8323C]/15 bg-[#E8DDD0]" />

            <div className="relative bg-[#FDFAF4] border border-[#A8323C]/50 px-6 sm:px-12 md:px-16 py-10 sm:py-14"
              style={{ outline: '1px solid rgba(168,50,60,0.15)', outlineOffset: '7px' }}>

              {/* Corner ornaments */}
              {['top-3 left-3', 'top-3 right-3', 'bottom-3 left-3', 'bottom-3 right-3'].map((pos, i) => (
                <span key={i} className={`absolute ${pos} text-[#A8323C] opacity-35 text-xl font-serif select-none`}>✦</span>
              ))}

              {/* Top label */}
              <p className="text-center text-xs tracking-[0.4em] uppercase text-[#8B6B5A] font-mono mb-8 border-b border-[#A8323C]/20 pb-5">
                25 · 07 · 2026
              </p>

              <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-10 md:gap-12">
                {[
                  { value: timeLeft.days, label: 'Дней' },
                  { value: timeLeft.hours, label: 'Часов' },
                  { value: timeLeft.minutes, label: 'Минут' },
                  { value: timeLeft.seconds, label: 'Секунд' },
                ].map(({ value, label }) => (
                  <div key={label} className="text-center space-y-3">
                    {/* Number with double underline */}
                    <div className="relative inline-block">
                      <div className="text-5xl sm:text-6xl md:text-7xl font-serif font-light text-[#A8323C]"
                        style={{ textShadow: '1px 2px 0 rgba(168,50,60,0.12)' }}>
                        {String(value).padStart(2, '0')}
                      </div>
                      <div className="absolute -bottom-1 left-0 right-0 h-px bg-[#A8323C]/30" />
                      <div className="absolute -bottom-3 left-2 right-2 h-px bg-[#A8323C]/15" />
                    </div>
                    <div className="text-xs tracking-[0.3em] uppercase text-[#8B6B5A] font-mono pt-4">
                      {label}
                    </div>
                  </div>
                ))}
              </div>

              {/* Bottom label */}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
